export default __webpack_public_path__ + "static/media/openDoor.498ba649.jpg";